import { useQuery } from "react-query";
import { ME } from "../constants";
import { me } from "./MeService";

const useMe = () => {
  return useQuery(ME, () => me(), {retry: false});
};

export default useMe;
